<template>
    <div style="height: 100%">
        <div class="sa-flexbox">
            <div class="sa-flexbox-footer" style="background-color: ciano">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ $i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm" />
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="xl" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-right head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template #cell(periodoTrattamento)="{ item }">
                            <span style="display: inline-block; white-space: nowrap"> Inizio: {{ formatDate(item.trattamentoDataInizio) }} </span>
                            <br />
                            <span style="display: inline-block; white-space: nowrap"> Fine: {{ formatDate(item.trattamentoDataFine) }} </span>
                        </template>

                        <template #cell(quote)="{ item }">
                            <div>
                                <span style="display: inline-block; white-space: nowrap"> ASL: {{ item.quotaAsl }} </span>
                                <br />
                                <span style="display: inline-block; white-space: nowrap"> Paziente: {{ item.quotaPaziente }} </span>
                                <br />
                                <span style="display: inline-block; white-space: nowrap"> Comune: {{ item.quotaComune }} </span>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    name: "RsaRiepiloghiRiepilogoImpegnativeListComponent",
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsaimpegnativa",
            items: [],
            fields: [
                { label: "N.", key: "index", thStyle: "width: 3rem" },
                { label: "Nome e cognome", key: "ospite" },
                { label: "Setting", key: "setting" },
                { label: "Livello", key: "livelli" },
                { label: "Prestazione", key: "impegnativaTipo" },
                { label: "Trattamento (inizio/fine)", key: "periodoTrattamento" },
                { label: "Quote", key: "quote" },
            ],
            currentPage: 1,
            perPage: 50,
            rows: 0,
        };
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.$emit("beforeLoadData");
            filtro = filtro || {};
            filtro.perPage = me.perPage;
            filtro.page = me.currentPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber + 1;
            me.$emit("afterLoadData", me.items);
        },

        loadDataError(error) {
            let me = this;
            console.error(error);
            me.$emit("afterLoadData");
        },
    },
};
</script>

<style scoped></style>
